class FeeObserver extends HTMLElement {
  constructor() {
    super();
    const listener = e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      // currentTarget is the button itself; e.target can be a child span
      // inside a styled button, and re-binding there would miss later clicks.
      const button = e.currentTarget;
      this.rebuildCartWithFees(
        () => {
          fetch('/cart.js')
            .then(resp => resp.json()).then(() => {
          // Re-click the button itself, not e.target: a click on the label span
          // has no form association, so Zapiet falls back to the first
          // form[action*="/cart"] on the page (a "Last Minute Additions" quick-add).
          button.click();
          button.addEventListener('click', listener, { once: true });
            })
        }
      )
    }

    // [data-cart-checkout] is the shared hook for the cart page's #checkout and
    // the cart drawer's checkout button (one surface per page).
    const checkoutButton = document.querySelector('[data-cart-checkout]') || document.querySelector('#checkout')

    if(checkoutButton) {
      checkoutButton.addEventListener('click', listener, { once: true });
    }
  }

  connectedCallback() {
    this.removeVirtualItemsFromCart();
  }

  removeVirtualItemsFromCart() {
    fetch(`${routes.cart_url}?view=api`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const virtualCartItems = Array.from(html.querySelectorAll('[data-virtual-cart-item]')).map(i => i.dataset);
        if(virtualCartItems.length === 0) return;

        const changeItems = virtualCartItems.reduce((acc, curr) => {acc[curr.virtualCartItem] = 0; return acc}, {});
        const headerSectionId = document.querySelector('.section-header').id.match(new RegExp('shopify-section-([-\\w]+)'))[1];
        const data = {
          updates: changeItems,
          sections: headerSectionId,
          sections_url: window.location.pathname,
        };

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(data) } })
          .then((response) => {
            return response.json();
          })
          .then((parsedState) => {
            const headerHtml = new DOMParser().parseFromString(parsedState.sections[headerSectionId], 'text/html').querySelector('.cart-count-bubble');
            const headerSection = document.querySelector('.cart-count-bubble');
            if(headerSection) {
              headerSection.innerHTML = headerHtml.innerHTML;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'temp-hold-observer', cartData: parsedState });
          })
          .catch((e) => { console.error(e) });
      }).catch((e) => { console.error(e) });
  }

  rebuildCartWithFees(callback) {
    const findNearest = (needle, haystack) => {
      if (!haystack || haystack.length === 0) return null;
      return haystack.reduce((prev, curr) => Math.abs(curr - needle) < Math.abs(prev - needle) ? curr : prev);
    };

    return fetch(`${routes.cart_url}?view=api`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const tempHoldVariants = Array.from(html.querySelectorAll('[data-fee-variant=temp_hold]')).map(i => i.dataset);
        const serviceFeeVariants = Array.from(html.querySelectorAll('[data-fee-variant=service_fee]')).map(i => i.dataset);
        const cartItems = Array.from(html.querySelectorAll('[data-cart-item]')).map(i => i.dataset);
        const feeCalculations = Array.from(html.querySelectorAll('[data-fee-calculation]')).map(i => i.dataset);

        const tempHoldFee = feeCalculations.find(f => f.feeCalculation === 'temp_hold').feeAmount;
        const serviceFee = feeCalculations.find(f => f.feeCalculation === 'service_fee').feeAmount;

        const tempHoldFeePercentage = feeCalculations.find(f => f.feeCalculation === 'temp_hold').feePercentage;
        const serviceFeePercentage = feeCalculations.find(f => f.feeCalculation === 'service_fee').feePercentage;

        const closestTempHold = findNearest(tempHoldFee, tempHoldVariants.map(v => v.amount));
        const closestServiceFee = findNearest(serviceFee, serviceFeeVariants.map(v => v.amount));

        const tempHoldVariantId = closestTempHold != null ? tempHoldVariants.find(v => v.amount === closestTempHold).id : null;
        const serviceFeeVariantId = closestServiceFee != null ? serviceFeeVariants.find(v => v.amount === closestServiceFee).id : null;

        // const changeItems = cartItems.reduce((acc, curr) => {acc[curr.cartItem] = Number(curr.cartQuantity); return acc}, {});
        //
        const bottleFeeData = html.querySelector('[data-bottle-fee]').dataset.bottleFee;
        const bottleFeeItems = Object.entries(JSON.parse(bottleFeeData).reduce((hash, id)=>{ hash[id] = (hash[id] || 0) + 1; return hash; }, {})).map(([id, quantity]) => ({id, quantity}));

        const cartEntries = cartItems.map(cartItem => {
          const rawData = JSON.parse(cartItem.cartRaw);
          const {id, properties, quantity} = rawData;
          if(properties['_ZapietId']) {
            properties['_ZapietId'] = properties['_ZapietId'].replaceAll('&amp;', '&');
          }
          return ({
            lineKey: cartItem.lineKey || '',
            parentKey: cartItem.parentKey || '',
            payload: {
              id,
              properties,
              quantity,
              ...(rawData?.selling_plan_allocation?.selling_plan?.id ? { selling_plan: rawData.selling_plan_allocation.selling_plan.id } : {})
            }
          })
        });

        // Nested cart lines (Flexi-Box): `item | json` drops parent_relationship,
        // so the api view exposes data-line-key/data-parent-key instead. Rebuild
        // the nesting via parent_id, keeping each child right after its parent
        // (the parent must precede its children in the add.js payload).
        const lineKeyToVariantId = cartEntries.reduce((acc, entry) => {
          if (entry.lineKey) acc[entry.lineKey] = entry.payload.id;
          return acc;
        }, {});
        const topLevelEntries = cartEntries.filter(entry => !entry.parentKey).reverse();
        const childEntries = cartEntries.filter(entry => entry.parentKey);
        const addItems = [];
        topLevelEntries.forEach(entry => {
          addItems.push(entry.payload);
          childEntries
            .filter(child => child.parentKey === entry.lineKey)
            .forEach(child => addItems.push({ ...child.payload, parent_id: entry.payload.id }));
        });
        // Orphaned children (parent line missing from the api view) fall back to flat re-add.
        childEntries
          .filter(child => !lineKeyToVariantId[child.parentKey])
          .forEach(child => addItems.push(child.payload));

        const addItemsWithFees = [
          ...(Number(serviceFee) > 0 && serviceFeeVariantId ? [{ id: serviceFeeVariantId, quantity: 1, properties: {'What is this?': `This is a ${serviceFeePercentage}% service fee for our in-store team to prepare your order with care.`} }] : []),
          ...(Number(tempHoldFee) > 0 && tempHoldVariantId ? [{ id: tempHoldVariantId, quantity: 1, properties: {'What is this?': `This is a temporary hold of ${tempHoldFeePercentage}% of your order value. Should we need to make any substitutions or weight-based price adjustments as we prepare your order, we'll update your cart value. Only then will your credit card be charged for the final item prices. For more details, see our FAQ's.` } }] : []),
          ...bottleFeeItems,
          ...addItems,
        ]

        fetch('/cart/clear.js').then(
          (resp) => resp.json()
        ).then(
            (resp) => {
              fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: JSON.stringify({items: addItemsWithFees}) } })
                .then((addResp) => addResp.json())
                .then(() => callback())
            }
          ).catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

customElements.define('fee-observer', FeeObserver);
